<ng-container>
  <ion-content>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button class="cancel-btn" fill="solid" (click)="cancel()">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title class="cart-title">Prepay Reservation</ion-title>
    </ion-toolbar>
    <ion-content style="height: 544px;" class="bg-lightgrey">
      <ion-grid>
        @for (package of reservationSectionPackages; track package; let i = $index) {
          <ion-row>
            @if (package.Quantity > 0) {
              <ion-col size="9">{{package.Quantity}}x &nbsp;{{getPackageName(package)}}
                @if (package.SpecialRequest != '') {
                  <ion-row class="specialRequest">
                    {{'SpecialRequest.SpecialRequest' | translate }}:
                    {{ package.SpecialRequest }}
                  </ion-row>
                }
              </ion-col>
            }
            @if (package.Quantity > 0) {
              <ion-col size="3" style="text-align: right;">
                <span>{{ package.Price * package.Quantity | currency }}</span>
              </ion-col>
            }
          </ion-row>
        }
      </ion-grid>

      <div class="bottom-division" style="position: absolute; width: 100%;">
        <reservation-checkout-total [reservationSectionPackages]="reservationSectionPackages" [options]="totalOptions" ></reservation-checkout-total>
        <ion-grid style="padding: 0;">
          <ion-row style="padding: 0;">
            <ion-col style="padding: 0;" >
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <ion-item class="total ion-text-center">
                      <ion-label style="text-align:left;">
                        <ion-button class="desktopMenu" (click)="cancel()" fill="clear">{{'General.Close' | translate}}
                        </ion-button>
                        <ion-icon class="mobileMenu" (click)="cancel()" name="reader-outline"></ion-icon>
                      </ion-label>

                    </ion-item>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-col>
            <ion-col>
              <ion-item  class="timeDelay ion-text-center" style="font-size:9pt; border:none;" >
                <ion-label style="text-align:left; font-size: 9pt;">
                  <ion-button class="ready estimateTime" style="font-size: 8pt; height:27px;color:white;" fill="clear">Prepay Reservation For: {{readyTime}}  </ion-button>
                  <ion-button class="smallReady estimateTime" style="font-size: 8pt; height:27px;color:white;"  fill="clear">Reservation: {{readyTime}}  </ion-button>
                </ion-label>
              </ion-item>
            </ion-col>
            <ion-col >
              <ion-item class="continue ion-text-center" style="--background: var(--ion-color-primary);">
                <ion-label style="text-align:right;">
                  <ion-button style="--color: var(--ion-color-primary-contrast, #fff);" (click)="submit()"
                  fill="clear">{{'General.Continue' | translate}}</ion-button>
                </ion-label>
                <ion-icon style="color: var(--ion-color-primary-contrast, #fff)" name="chevron-forward-outline" item-right></ion-icon>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-content>
  </ion-content>
</ng-container>